import dynamic from 'next/dynamic';
import type { SyntaxHighlighterProps } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/hljs';

// Use the light build and register only the languages we need (~30KB vs ~1MB)
const SyntaxHighlighter = dynamic<SyntaxHighlighterProps>(
    () =>
        import('react-syntax-highlighter/dist/esm/light').then(async (mod) => {
            const SHL = mod.default;
            // Register only the languages defined in Contentful's codeBlock content type
            const [javascript, typescript, css, php, bash, twig, json] = await Promise.all([
                import('react-syntax-highlighter/dist/esm/languages/hljs/javascript'),
                import('react-syntax-highlighter/dist/esm/languages/hljs/typescript'),
                import('react-syntax-highlighter/dist/esm/languages/hljs/css'),
                import('react-syntax-highlighter/dist/esm/languages/hljs/php'),
                import('react-syntax-highlighter/dist/esm/languages/hljs/bash'),
                import('react-syntax-highlighter/dist/esm/languages/hljs/twig'),
                import('react-syntax-highlighter/dist/esm/languages/hljs/json'),
            ]);
            SHL.registerLanguage('javascript', javascript.default);
            SHL.registerLanguage('typescript', typescript.default);
            SHL.registerLanguage('css', css.default);
            SHL.registerLanguage('php', php.default);
            SHL.registerLanguage('bash', bash.default);
            SHL.registerLanguage('twig', twig.default);
            SHL.registerLanguage('json', json.default);
            // jsx/tsx map to javascript/typescript in hljs
            SHL.registerLanguage('jsx', javascript.default);
            SHL.registerLanguage('tsx', typescript.default);
            return { default: SHL as unknown as React.ComponentType<SyntaxHighlighterProps> };
        }),
    { ssr: false }
);

export interface FormattedCodeProps {
    language: string;
    code: string;
}

export function FormattedCode(props: FormattedCodeProps) {
    const { code, language } = props;

    return (
        <SyntaxHighlighter language={language} style={dracula}>
            {code}
        </SyntaxHighlighter>
    );
}

export default FormattedCode;
